export default "__VITE_ASSET__DU2yw20K__"